import React from "react";
import { useLeadLinkClick } from "web/react/hooks/use-lead-link-click/use-lead-link-click";

interface LeadLinkProps {
    href: string;
    children?: React.ReactNode;
    eventCategory?: string;
    eventAction?: string;
    eventLabel?: string;
    eventCustomData?: Record<string, unknown>;
    eventTruncate?: boolean;
    productId?: string;
    reason: string;
    beforeOnClick?: (
        processClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void,
        event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
    ) => void;
    afterOnClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
    className?: string;
    fromUrl?: string;
    openInNewTab?: boolean;
    type?: string;
    rel?: string;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    dataTestId?: string;
}

export function LeadLink({
    href,
    children,
    eventCategory,
    eventAction,
    eventLabel,
    eventCustomData,
    eventTruncate,
    productId,
    reason,
    beforeOnClick,
    afterOnClick,
    className,
    fromUrl,
    openInNewTab = false,
    type,
    rel,
    onMouseEnter = () => {},
    onMouseLeave = () => {},
    dataTestId,
}: LeadLinkProps): React.ReactElement {
    const { onClick, leadHref } = useLeadLinkClick({
        href,
        type,
        fromUrl,
        beforeOnClick,
        productId,
        reason,
        openInNewTab,
        eventCategory,
        eventAction,
        eventLabel,
        eventCustomData,
        eventTruncate,
        afterOnClick,
    });

    return (
        // This could be considered a security issue. We need to review as we do use window.opener in some cases
        // eslint-disable-next-line react/jsx-no-target-blank
        <a
            className={className}
            href={leadHref}
            rel={rel || undefined}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            target={openInNewTab ? "_blank" : undefined}
            dangerouslySetInnerHTML={
                typeof children === "string" ? { __html: children } : undefined
            }
            data-testid={dataTestId}
        >
            {typeof children !== "string" ? children : null}
        </a>
    );
}
